// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#switch-container {
  display: flex;
}
#switch-container .switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 22px;
}
#switch-container .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
#switch-container .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #61c454;
  background-color: rgba(97, 196, 84, 0.2);
  transition: 0.4s;
}
#switch-container .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: #61c454;
  transition: 0.4s;
}
#switch-container input:checked + .slider {
  background-color: rgba(238, 106, 95, 0.2);
  border: 1px solid #ee6a5f;
}
#switch-container input:checked + .slider:before {
  background-color: #ee6a5f;
}
#switch-container input:checked + .slider:before {
  transform: translateX(22px);
}
#switch-container .slider.round {
  border-radius: 34px;
}
#switch-container .slider.round:before {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/inputs/Switch/Switch.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAcE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAZJ;AAeE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,wCAAA;EAEA,gBAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EAEA,gBAAA;AAfJ;AAkBE;EACE,yCAAA;EACA,yBAAA;AAhBJ;AAkBE;EACE,yBAAA;AAhBJ;AAmBE;EAGE,2BAAA;AAjBJ;AAmBE;EACE,mBAAA;AAjBJ;AAoBE;EACE,kBAAA;AAlBJ","sourcesContent":["#switch-container {\r\n  display: flex;\r\n  // .form-check-input {\r\n  //   border: 1px solid #61c454;\r\n  //   background-color: #61c45433;\r\n  //   width: 44px;\r\n  //   height: 22px;\r\n  //   cursor: pointer;\r\n  //   &:focus {\r\n  //     box-shadow: unset;\r\n  //   }\r\n  // }\r\n  // .form-check-input:checked {\r\n  //   border: 1px solid #ee6a5f;\r\n  //   background-color: #ee6a5f33;\r\n  // }\r\n  .switch {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 44px;\r\n    height: 22px;\r\n  }\r\n\r\n  .switch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n  }\r\n\r\n  .slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border: 1px solid #61c454;\r\n    background-color: #61c45433;\r\n    -webkit-transition: 0.4s;\r\n    transition: 0.4s;\r\n  }\r\n\r\n  .slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 16px;\r\n    width: 16px;\r\n    left: 2px;\r\n    bottom: 2px;\r\n    background-color: #61c454;\r\n    -webkit-transition: 0.4s;\r\n    transition: 0.4s;\r\n  }\r\n\r\n  input:checked + .slider {\r\n    background-color: #ee6a5f33;\r\n    border: 1px solid #ee6a5f;\r\n  }\r\n  input:checked + .slider:before {\r\n    background-color: #ee6a5f;\r\n  }\r\n\r\n  input:checked + .slider:before {\r\n    -webkit-transform: translateX(22px);\r\n    -ms-transform: translateX(22px);\r\n    transform: translateX(22px);\r\n  }\r\n  .slider.round {\r\n    border-radius: 34px;\r\n  }\r\n\r\n  .slider.round:before {\r\n    border-radius: 50%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
